import { config, timezones } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useBranchLogic = () => {
  const apiRoute = "branches";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "Name",
      label: "Branch name",
      type: "text",
      isRequired: true,
      err: "Branch name is required",
    },
    {
      name: "country",
      label: "Country",
      type: "dropdown",
      isRequired: true,
      err: "Country is required",
      returnID: true,
    },
    {
      name: "code",
      label: "Branch code",
      type: "text",
      isRequired: true,
      err: "Branch code is required",
    },
    {
      name: "legal_name",
      label: "Legal name",
      type: "text",
      isRequired: true,
      err: "Legal name is required",
    },
    {
      name: "timezone",
      label: "Timezone",
      type: "dropdown",
      isRequired: true,
      returnID: true,
      err: "Timezone is required",
      data: timezones,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      isRequired: false,
      err: "Email is required",
    },
    {
      name: "phone_number",
      label: "Phone number",
      type: "phone",
      isRequired: true,
      err: "Phone number is required",
    },
    {
      name: "fax",
      label: "Fax",
      type: "text",
      isRequired: false,
      err: "Fax is required",
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      isRequired: true,
      err: "Address is required",
    },
    {
      name: "latitude",
      label: "Latitude",
      type: "text",
      isRequired: false,
      err: "Latitude is required",
      decimalCount: 12,
    },
    {
      name: "longitude",
      label: "Longitude",
      type: "text",
      isRequired: false,
      err: "Longitude is required",
      decimalCount: 12,
    },
    {
      name: "vat",
      label: "VAT",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "VAT is required",
    },
    {
      name: "grace_period",
      label: "Grace period",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Grace period is required",
    },

    // {
    //   name: 'currencies',
    //   label: 'Branch Currencies',
    //   type: 'multiSelect',
    //   isRequired: false,
    //   err: 'Branch Currencies is required'
    // },
    {
      name: "security_deposit_amount",
      label: "Security deposit",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Security deposit is required",
    },
    {
      name: "accident_charge",
      label: "Accident charge",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Accident charge is required",
    },
    {
      name: "cash_surcharge",
      label: "Cash surcharge",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Cash surcharge is required",
    },
    {
      name: "legal_driving_age",
      label: "Legal driving age",
      type: "number",
      minValue: 16,
      isRequired: true,
      err: "Legal driving age is required",
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: true,
      err: "Currency is required",
      returnID: true,
      span: 2,
    },
    {
      name: "frontend_cutoff_date",
      label: "Frontend cutoff date",
      type: "datepicker",
      allowTime: false,
      isClearable: true,
      span: 2,
    },
    {
      name: "docs_link",
      label: "Files Link",
      type: "linkButton",
      isRequired: false,
      span: 2,
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const rentalPartnerRole = process.env.REACT_APP_PARTNER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin, rentalPartnerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(config, "currencies", "currency", temp, "code"),
      fetchDataAndMapToField(config, "cities/countries", "country", temp),
    ];
  };
  return {
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
    initFields,
    apiRoute,
  };
};

export default useBranchLogic;
